<header fxHide.lt-md>
  <div class="nav">
    <ul fxLayout="row">

      <li *ngIf="perfilUsuario === 1">
        <a class="black-text" routerLink="/hao" [routerLinkActive]="['active']">
          HAO
        </a>
      </li>

      <li *ngIf="perfilUsuario === 2">
        <a class="black-text" routerLink="web-admin" [routerLinkActive]="['active']">
          WebAdmin
        </a>
      </li>

      <li *ngIf="perfilUsuario === 2 || perfilUsuario === 4">
        <a class="black-text" routerLink="login-metric" [routerLinkActive]="['active']">
          Metrica Login
        </a>
      </li>

      <li *ngIf="perfilUsuario === 2 || perfilUsuario === 4">
        <a class="black-text" routerLink="share" [routerLinkActive]="['active']">
          Compartilhamento
        </a>
      </li>

      <li *ngIf="perfilUsuario === 3">
        <a class="black-text" routerLink="headhunter" [routerLinkActive]="['active']">
          Lista de Candidatos
        </a>
      </li>

      <li *ngIf="perfilUsuario === 1 || perfilUsuario === 3 || perfilUsuario === 2">
        <a class="black-text" routerLink="configuracao" [routerLinkActive]="['active']">
          Configuração
        </a>
      </li>

    </ul>
  </div>
</header>
